import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LogoLoader } from "@/components/LogoLoader";
import { consumeAfterLogin } from "@/lib/postLogin";

// Dedicated Google OAuth callback. Google redirects here with ?code=&state=.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthGoogle() {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const savedState = sessionStorage.getItem("os_oauth_state");
    sessionStorage.removeItem("os_oauth_state");

    if (!code) {
      navigate("/login", { replace: true });
      return;
    }
    if (!state || state !== savedState) {
      setError("Sign-in verification failed. Please try again.");
      setTimeout(() => navigate("/login", { replace: true }), 2000);
      return;
    }

    (async () => {
      try {
        const redirectUri = window.location.origin + "/auth/google";
        const { data } = await api.post("/auth/google", { code, redirect_uri: redirectUri });
        applyAuth(data.token, data.user);
        if (consumeAfterLogin(navigate)) return;
        navigate("/feed", { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail;
        setError(typeof detail === "string" ? detail : "Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 2500);
      }
    })();
  }, [navigate, applyAuth]);

  return (
    <LogoLoader testId="auth-google-callback" label={error || "Establishing secure session..."} />
  );
}
